import { connect } from 'react-redux';
import CustomCrop from './custom_crop';
import { setCrop } from '../../actions/crop';
import { automaticPreview } from '../../selectors/preview';

const mapStateToProps = (state) => {
  const { custom } = state.crop;
  const { dpi } = state.canvas;
  return {
    ...automaticPreview(state),
    custom,
    dpi
  };
};

export default connect(mapStateToProps, { setCrop })(CustomCrop);
